import { render } from "./GasCompData.vue?vue&type=template&id=8c040442"
import script from "./GasCompData.vue?vue&type=script&lang=js"
export * from "./GasCompData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__